import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { apiGetBookById } from '../api';
import SEO from '../components/common/SEO';
import ProductDetail from './ProductDetail';
import { SkeletonBookDetail } from '../components/common/Skeleton';
import logger from '../utils/logger';

const BookDetail = () => {
  const { id } = useParams();
  const [book, setBook] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    apiGetBookById(id)
      .then((data) => setBook(data.book || data))
      .catch((e) => logger.error('Failed to load book', e))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <SkeletonBookDetail />;
  }

  if (!book) {
    return (
      <div className="w-full mx-auto px-4 py-16 text-center">
        <h2 className="text-2xl font-bold text-black">Book not found</h2>
        <Link to="/shop" className="text-orange-600 hover:underline mt-4 inline-block">
          Browse all books
        </Link>
      </div>
    );
  }

  return (
    <>
      <SEO
        title={book.title}
        description={book.description?.slice(0, 160) || `Buy ${book.title} by ${book.author} online at Ekamithila.`}
        keywords={`${book.title}, ${book.author}, buy book online`}
        image={book.image}
        type="product"
      />
      <ProductDetail book={book} />
    </>
  );
};

export default BookDetail;
